<template>
  <Modal v-model="showModal" title="课程详情" :footer-hide="true" width="735" class="top">
    <Table :columns="columns" :data="tableData" border>
      <template slot-scope="{ row }" slot="action">
        <a class="table-btn" @click="previewFile(row, 1)">预览</a>
      </template>

      <template slot-scope="{ row }" slot="columnName">
        <p v-for="(item, index) in row.columnName" :key="index">{{ item }}</p>
      </template>
    </Table>
  </Modal>
</template>
<script>
import { filterTime } from '@/api/filter';
export default {
  data() {
    return {
      showModal: false,
      tableData: [],
      articleType: null,
      columns: [
        {
          title: '课程名称',
          key: 'name',
          align: 'left',
          width: 400,
          tree: true,
          tooltip: true
        },
        {
          title: '更新时间',
          align: 'center',
          width: 220,
          render(h, params) {
            return <span>{filterTime(params.row.uploadTime, 'YYYY-MM-DD HH:mm')}</span>;
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          slot: 'action'
        }
      ]
    };
  },

  methods: {
    open(list, articleType) {
      this.showModal = true;
      this.tableData = list;
      this.articleType = articleType;
    },

    // 预览
    previewFile(data) {
      window.open(data.url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  margin-top: 5px;
  .title {
    font-size: 15px;
    font-weight: bold;
  }
  .material {
    display: flex;
    .material-config {
      margin-left: 0px;
      height: 20px;
      margin-top: 6px;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .action {
        color: #236dff;
      }
    }
  }
}
/deep/ .ivu-modal-header {
  height: 40px;
  padding-left: 20px !important;
}
/deep/ .ivu-modal-header-inner {
  font-size: 14px !important;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
  font-size: 34px;
}
</style>
